import public_tool from '@/common/public.js';
import { PERMISSIONS, permissionIDs } from '../config/permission';

function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]' && val !== null && val !== undefined;
}

class PermissionManager {
  constructor(isIos) {
    this.isIos = isIos || false;
  }

  // iOS推送权限检查
  judgeIosPermissionPush() {
    let enabledTypes = 0;
    const UIApplication = plus.ios.import('UIApplication');
    const app = UIApplication.sharedApplication();
    if (app.currentUserNotificationSettings) {
      const settings = app.currentUserNotificationSettings();
      enabledTypes = settings.plusGetAttribute('types');
      plus.ios.deleteObject(settings);
    } else {
      enabledTypes = app.enabledRemoteNotificationTypes();
    }
    const result = Number(enabledTypes) !== 0;
    plus.ios.deleteObject(app);
    plus.ios.deleteObject(UIApplication);
    return result;
  }

  // iOS定位权限检查
  judgeIosPermissionLocation() {
    const CLLocationManager = plus.ios.import('CLLocationManager');
    const status = CLLocationManager.authorizationStatus();
    const result = Number(status) !== 2;
    plus.ios.deleteObject(CLLocationManager);
    return result;
  }

  // iOS麦克风权限检查
  judgeIosPermissionAudioSession() {
    const AVAudioSession = plus.ios.import('AVAudioSession');
    const sharedInstance = AVAudioSession.sharedInstance();
    const recordPermission = sharedInstance.recordPermission();
    const result = Number(recordPermission) !== 1684369017 && Number(recordPermission) !== 1970168948;
    plus.ios.deleteObject(avaudiosession);
    return result;
  }

  // iOS相机权限检查
  judgeIosPermissionCamera() {
    const AVCaptureDevice = plus.ios.import('AVCaptureDevice');
    const authStatus = AVCaptureDevice.authorizationStatusForMediaType('vide');
    const result = Number(authStatus) === 3;
    plus.ios.deleteObject(AVCaptureDevice);
    return result;
  }

  // iOS相册权限检查
  judgeIosPermissionPhotoLibrary() {
    const PHPhotoLibrary = plus.ios.import('PHPhotoLibrary');
    const authStatus = PHPhotoLibrary.authorizationStatus();
    const result = Number(authStatus) === 3;
    plus.ios.deleteObject(PHPhotoLibrary);
    return result;
  }

  // iOS通讯录权限检查
  judgeIosPermissionContact() {
    const CNContactStore = plus.ios.import('CNContactStore');
    const cnAuthStatus = CNContactStore.authorizationStatusForEntityType(0);
    const result = Number(cnAuthStatus) === 3;
    plus.ios.deleteObject(CNContactStore);
    return result;
  }

  // iOS日历权限检查
  judgeIosPermissionCalendar() {
    const EKEventStore = plus.ios.import('EKEventStore');
    const ekAuthStatus = EKEventStore.authorizationStatusForEntityType(0);
    const result = Number(ekAuthStatus) === 3;
    plus.ios.deleteObject(EKEventStore);
    return result;
  }

  // iOS备忘录权限检查
  judgeIosPermissionMemo() {
    const EKEventStore = plus.ios.import('EKEventStore');
    const ekAuthStatus = EKEventStore.authorizationStatusForEntityType(1);
    const result = Number(ekAuthStatus) === 3;
    plus.ios.deleteObject(EKEventStore);
    return result;
  }

  // iOS打电话权限检查
  judgeIosPermissionCallPhone() {
    // const CTCellularData = plus.ios.import('CTCellularData');
    // const cellularData = new CTCellularData();
    // const authStatus = cellularData.restrictedState();
    // const result = Number(authStatus) === 1;
    // plus.ios.deleteObject(CTCellularData);
    return true;
  }

  // iOS发短信权限检查
  judgeIosPermissionSendSMS() {
    // const CTCellularData = plus.ios.import('CTCellularData');
    // const cellularData = new CTCellularData();
    // const authStatus = cellularData.restrictedState();
    // const result = Number(authStatus) === 1;
    // plus.ios.deleteObject(CTCellularData);
    return true;
  }

  // ios权限检查
  judgeIosPermission(permissionID) {
    const permissionFunctions = {
      location: this.judgeIosPermissionLocation,
      camera: this.judgeIosPermissionCamera,
      album: this.judgeIosPermissionPhotoLibrary,
      record: this.judgeIosPermissionAudioSession,
      push: this.judgeIosPermissionPush,
      contact: this.judgeIosPermissionContact,
      calendar: this.judgeIosPermissionCalendar,
      memo: this.judgeIosPermissionMemo,
      callPhone: this.judgeIosPermissionCallPhone,
      sendSMS: this.judgeIosPermissionSendSMS,
    };

    const permissionCheckFunction = permissionFunctions[permissionID];
    return permissionCheckFunction ? permissionCheckFunction() : false;
  }

  // 请求Android权限
  async requestAndroidPermission(permissionID) {
    try {
      return await new Promise((resolve, reject) => {
        plus.android.requestPermissions(
          [permissionID], // 理论上支持多个权限同时查询，但实际上本函数封装只处理了一个权限的情况。有需要的可自行扩展封装
          (resultObj) => {
            let result = 0;
            for (let i = 0; i < resultObj.granted.length; i++) {
              // const grantedPermission = resultObj.granted[i];
              // console.log('已获取的权限：' + grantedPermission);
              result = 1;
            }
            for (let i = 0; i < resultObj.deniedPresent.length; i++) {
              // const deniedPresentPermission = resultObj.deniedPresent[i];
              // console.log('拒绝本次申请的权限：' + deniedPresentPermission);
              result = 0;
            }
            for (let i = 0; i < resultObj.deniedAlways.length; i++) {
              // const deniedAlwaysPermission = resultObj.deniedAlways[i];
              // console.log('永久拒绝申请的权限：' + deniedAlwaysPermission);
              result = -1;
            }
            resolve(result === 1);
          },
        );
      });
    } catch (error) {
      console.error('申请权限错误：', error);
      return { code: error.code, message: error.message };
    }
  }

  // 跳转到应用权限设置页面
  gotoAppPermissionSetting() {
    if (this.isIos) {
      const UIApplication = plus.ios.import('UIApplication');
      const sharedApplication = UIApplication.sharedApplication();
      const NSURL = plus.ios.import('NSURL');
      const settings = NSURL.URLWithString('app-settings:');
      sharedApplication.openURL(settings);
      plus.ios.deleteObject(settings);
      plus.ios.deleteObject(NSURL);
      plus.ios.deleteObject(sharedApplication);
    } else {
      const Intent = plus.android.importClass('android.content.Intent');
      const Settings = plus.android.importClass('android.provider.Settings');
      const Uri = plus.android.importClass('android.net.Uri');
      const mainActivity = plus.android.runtimeMainActivity();
      const intent = new Intent();
      intent.setAction(Settings.ACTION_APPLICATION_DETAILS_SETTINGS);
      const uri = Uri.fromParts('package', mainActivity.getPackageName(), null);
      intent.setData(uri);
      mainActivity.startActivity(intent);
    }
  }

  // 请求权限
  async requestPermission(permissionID, jumpToSetting = true) {
    const settings = public_tool.GetSettings();
    const authorizedPermissions = isObject(settings.authorizedPermissions) ? settings.authorizedPermissions : {};
    const isFirst = typeof authorizedPermissions[permissionID] === 'undefined';
    const currentPermission = PERMISSIONS[permissionID];

    let state = false;
    let isClickCancel = false;
    if (this.isIos) {
      state = this.judgeIosPermission(permissionID);
    } else {
      state = await this.requestAndroidPermission(currentPermission.android);
    }

    if (state) {
      authorizedPermissions[permissionID] = state;
      settings.authorizedPermissions = authorizedPermissions;
      public_tool.SetSettings(settings);
    }

    if (this.isIos && isFirst) {
      return new Promise((resolve) => {
        resolve(true);
      });
    }

    if (!state && jumpToSetting && !isFirst) {
      await new Promise((resolve) => {
        uni.showModal({
          title: '提示',
          content: `${currentPermission.name}权限未开启，是否前往设置页面开启？`,
          success: (res) => {
            if (res.confirm) {
              this.gotoAppPermissionSetting();
            } else if (res.cancel) {
              isClickCancel = true;
            }
            resolve();
          },
        });
      });
    }
    return new Promise((resolve, reject) => {
      if (isClickCancel) {
        resolve(false);
      } else if (state) {
        resolve(state);
      } else {
        reject();
      }
    });
  }

  // 请求应用权限
  async requestApplicationPermission(permissionID, jumpToSetting = true) {
    const settings = public_tool.GetSettings();
    const authorizedPermissions = isObject(settings.authorizedPermissions) ? settings.authorizedPermissions : {};
    const isFirst = typeof authorizedPermissions[permissionID] === 'undefined';
    const currentPermission = PERMISSIONS[permissionID];

    if (Array.isArray(permissionID)) {
      const permissions = [];
      for (let i = 0; i < permissionID.length; i++) {
        permissions[i] = await this.requestApplicationPermission(permissionID[i]);
      }
      return permissions.filter(Boolean).length === permissionID.length;
    }

    if (typeof plus === 'undefined') {
      // console.error('非APP环境，无法申请权限');
      return new Promise((resolve) => {
        resolve(true);
      });
    }
    if (!permissionIDs.includes(permissionID)) {
      console.error('非法的权限申请');
      return new Promise((resolve, reject) => {
        reject();
      });
    }

    if (isFirst && !this.isIos) {
      // uni.showToast({
      //   title: currentPermission.tips,
      //   duration: 5000,
      //   position: 'top',
      // });
      return new Promise((resolve) => {
        uni.showModal({
          title: '提示',
          content: currentPermission.tips,
          success: async (res) => {
            if (res.confirm) {
              resolve(await this.requestPermission(permissionID, jumpToSetting));
            }
          },
        });
      });
    }

    return await this.requestPermission(permissionID, jumpToSetting);
  }
}

module.exports = PermissionManager;
